import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-rightmenu',
    templateUrl: './app.rightmenu.component.html'
})
/** Right-panel host — thin wrapper that delegates `rightMenuActive` to `LayoutService.state`. */
export class AppRightMenuComponent {

    constructor(public layoutService: LayoutService) { }

    /** `true` when the right side-panel is open. */
    get rightMenuActive(): boolean {
        return this.layoutService.state.rightMenuActive;
    }

    /** Opens or closes the right side-panel by writing to `LayoutService.state`. */
    set rightMenuActive(_val: boolean) {
        this.layoutService.state.rightMenuActive = _val;
    }


}
